module.exports = __webpack_public_path__ + "static/media/redux-quiz.ac11f3dc.png";